import { SubMenuOption } from './object-browser';
import { IconDetail } from './tooltip-icon';

export type CatalogAccessLevel = 'NONE' | 'READONLY' | 'WRITE' | 'FULL';

/**
 * The CatalogObject model is the model base of Project, Layer and Category models.
 */

export declare class CatalogObject {
    creatorUserId: string;
    /** Indicates the last time the project was opened */
    accessedAt: Date | null;
    /** indicates if this category is readonly or we have full acces level */
    accessLevel: CatalogAccessLevel;
    /** creation date */
    createdAt: Date | string;
    /** user id who create it */
    createdBy: number | null;
    /** company id where is created */
    createdByCompany: string | null;
    id: number;
    description?: string;
    name: string;
    /** last date of updating */
    updatedAt?: Date | string;
    /** indicate catalog object type */
    type?: CatalogObjectTypes;
    thumbnail: string | null;
    redirectThumbnail?: string | null;
    permissions?: CatalogObjectPermissions;

    getId(): number;
    getAccessLevel(): CatalogAccessLevel;
    getName(): string;
}

export interface CatalogObjectPermissions {
    viewPermission: boolean;
    updatePermission: boolean;
    deletePermission: boolean;
}

export type CatalogObjectPermissionsType = keyof CatalogObjectPermissions;

export enum CatalogObjectTypesEnum {
    projects = 'projects',
    layers = 'layers',
    categories = 'categories',
    jobSites = 'sites',
}

export type CatalogObjectTypes = 'projects' | 'layers' | 'categories' | 'sites';

export interface CatalogObjectSelection {
    catalogObject: CatalogObject;
    selected: boolean;
    iconDetail?: IconDetail[];
    secondaryMenuOptions?: SubMenuOption[];
}
